import { isCommonError, isObjectRecord } from '@/libs/typeguard/isError';
import type { CommonError } from 'ap-openapi';

export const extractCommonErrorFromBlob = async (
  data: unknown
): Promise<CommonError | null> => {
  if (!(data instanceof Blob) || !data.type.includes('application/json')) {
    throw new Error('Unexpected error response: not an application/json blob');
  }

  try {
    const parsed: unknown = JSON.parse(await data.text());
    if (isObjectRecord(parsed) && isCommonError(parsed)) {
      return {
        messages: Array.isArray(parsed.messages) ? parsed.messages : undefined,
        code: typeof parsed.code === 'string' ? parsed.code : undefined,
      };
    }
  } catch {
    return null;
  }

  return null;
};
